module.exports = __webpack_public_path__ + "static/media/brand-alibaba.bd009beb.png";